import { IconBookmark, IconBuildings, IconCoil, IconEnergyCircle, IconRuler, IconShare, IconSignal, IconTools } from '@assets/images/icon';
import { bell1 } from '@assets/images/main/iot/product';
import { airQuality1, coMeasure1, sensorThumb } from '@assets/images/main/sensor';

export default {
  a: [
    { text: '주요 용도', icon: IconCoil },
    { text: '측정 항목', icon: IconRuler },
    { text: '통신 대역', icon: IconSignal },
    { text: '설치 환경', icon: IconEnergyCircle },
    { text: '전원 방식', icon: IconTools },
    { text: '특징 요약', icon: IconBuildings },
    { text: 'ORBRO 연동 여부', icon: IconBookmark },
    { text: '외부 연동', icon: IconShare },
  ],

  b: [
    { text: '산업현장 설비 상태 감지' },
    { text: '온도, 습도, 누수, 압력, 진동, 접점 등' },
    { text: 'LoRA, RS-485' },
    { text: '공사현장, 플랜트, 물류창고 등' },
    { text: '배터리 / DC 전원' },
    { text: '다양한 센서 입력 대응, 6km LoRA 무선 통신 지원' },
    { text: '지원' },
    { text: 'API 제공' },
  ],

  c: [
    { text: 'CO₂ 누출 감지 및 경고' },
    { text: '일산화탄소, 온도' },
    { text: 'Wi-Fi, RS-485' },
    { text: '밀폐 구역, 하수처리장, 폐기물 시설 등' },
    { text: '배터리 / DC 전원' },
    { text: '유해환경 감지를 위한 CO₂ 특화 센서, 민감·위험 구역에 적합' },
    { text: '지원' },
    { text: 'API 제공' },
  ],

  d: [
    { text: '실내 공기질 모니터링' },
    { text: '미세먼지, CO₂, TVOC, 온습도' },
    { text: 'Wi-Fi, RS-485' },
    { text: '병원, 사무실, 공공시설 등 실내 환경' },
    { text: 'DC 24V' },
    { text: '고정밀 공기질 분석, 환경부 인증' },
    { text: '지원' },
    { text: 'API 제공' },
  ],

  e: [
    { text: '긴급 상황 알림 전송' },
    { text: '비상 버튼 상태' },
    { text: 'Bluetooth 5, Wi-Fi' },
    { text: '병원, 창고, 오피스, 현장 복도' },
    { text: 'AAA 배터리' },
    { text: '문자 전송, Wi-Fi 연동, 저전력 운영' },
    { text: '지원' },
    { text: 'API 제공' },
  ],

  spec: [
    {},

    {
      image: sensorThumb,
      link: '/iot/LoRASensor',
      title: 'LoRA 센서',
      desc: 'New',
    },
    {
      image: coMeasure1,
      link: '/iot/co2',
      title: 'CO₂ 측정기',
      desc: 'New',
    },

    {
      image: airQuality1,
      link: '/iot/air',
      title: '공기품질 측정기',
      desc: 'New',
    },
    {
      image: bell1,
      link: '/iot/bell',
      title: '비상벨',
      desc: '',
    },
  ],
};
